/*
 * @Description:
 * @Author: 诺
 * @Date: 2022-04-07 15:39:51
 * @LastEditors: 诺
 * @LastEditTime: 2022-05-10 15:00:19
 */
import yqAnalytics from "yq-analytics";
import Vue from "vue/dist/vue.js";
/**
 * 获取埋点的基础数据
 */
export async function handlerGetYqAnalyticsPropertyValueBaseData() {
  let propertyValue = {};
  return new Promise((resolve, reject) => {
    // let waitingDataInterval = setInterval(() => {
    const actCode = Vue.prototype.$actCode || "";
    const openId = Vue.prototype.$openid || "";
    const appId = Vue.prototype.$appId || "";
    const projectId = Vue.prototype.$projectId || "";
    propertyValue = {
      ...propertyValue,
      actCode,
      openId,
      appId,
      projectId,
      bizType: "act_center",
      bizId: actCode,
    };
    resolve(propertyValue);
    // clearInterval(waitingDataInterval);
    // }, 200)
  });
}

/**
 * 埋点事件
 */
export async function handlerYqAnalyticsEvent(eventId, propertyValue) {
  let propertyValueBaseData = await handlerGetYqAnalyticsPropertyValueBaseData();
  propertyValueBaseData = {
    ...propertyValueBaseData,
    ...propertyValue,
  };
  console.log(propertyValueBaseData);
  yqAnalytics.triggerEvent({
    eventId,
    propertyValue: JSON.stringify(propertyValueBaseData),
  });
}
